var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"sh-fade-transition"}},[(_vm.value)?_c('div',{staticClass:"sh-modal"},[_c('div',{staticClass:"sh-modal-bg",on:{"click":function($event){_vm.persistent ? null : _vm.close()}}}),_vm._v(" "),_c('div',{staticClass:"sh-modal-content h-100 col-12 col-sm-10 col-md-10 col-lg-6 col-xl-6"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce0a689","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = null
// module chunks = 